export default "__VITE_ASSET__qNXV6s9s__"